import styled from 'styled-components'

// Inline content sits inside a typography component, so it needs no block
// rules - only the emphasis the global reset clears.
export const ConversationMarkdownInlineStyled = styled.span`
  em {
    font-style: italic;
  }
`
